<p-toast position="top-right" key="default"/>
<p-toast position="top-center" key="headless" [baseZIndex]="5000" class="overflow-clip border-none! w-200!">
  <ng-template let-message let-closeFn="closeFn" #headless>
    <section
      class="relative flex flex-col p-8 gap-4 w-full bg-cyan-300/40 backdrop-blur-sm rounded-xl border border-cyan-500">
      <div class="flex items-center gap-5 text-cyan-600">
        <i class="pi pi-exclamation-circle text-4xl!"></i>
        <span class="font-bold text-base text-center">{{ message.summary }}</span>
      </div>
    </section>
    <div class="p-2 cursor-pointer absolute top-2 right-2" (click)="closeFn($event)">
      <i class="pi pi-times"></i>
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog [style]="{ width: '460px', maxWidth: '92vw' }" [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"/>
<router-outlet/>
